import React from "react";
import styles from "./AuxilaryServices.module.css";
import AuxiliaryWaves from "../../../../components/UI/AuxiliaryWaves";
import AuxiliaryTab from "../../../../components/UI/foreign-patient/AuxiliaryTab";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../../App";
import { useContext } from "react";

const AuxilaryServices = ({ data }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

const { setIsBackNavigation } = useContext(NavigationContext);

  // const data = {
  //   showTitle: true,
  //   subTitle: "Testimonials",
  //   title:
  //     '<p><span style="font-size: 36px">Auxiliary <span style="color: rgb(127, 74, 155)">Services</span></span></p>',
  // };

  return (
    <section className={styles.section} id="auxiliary-services-home">
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      {/* <AuxiliaryTab className={styles.patternTab} /> */}
      <img
        className={styles.patternTab}
        src="/img/patterns/auxiliary-tab.svg"
      />
      <AuxiliaryWaves className={styles.pattern} />
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            data-aos="fade-down"
            data-aos-delay="150"
            className={styles.mainImage}
            src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
          />
        </div>
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.titleFirst}>
              <h2
                data-aos="fade-right"
                data-aos-delay="150"
                dangerouslySetInnerHTML={{ __html: data?.title }}
              ></h2>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          <div className={styles.imageWrapper2}>
            <img
              className={styles.mainImage2}
              src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
            data-aos="fade-down"
                data-aos-delay="150"
            />
          </div>
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          <button
            data-aos="fade-down"
            data-aos-delay="150"
            className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
            onClick={()=>{
               const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            setIsBackNavigation(true)
              navigate(`/pages/${data?.listingItems[0]?.slug}`)}}
          >
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default AuxilaryServices;
